import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { NgClass } from "@angular/common";

@Component({
    selector: "rask-busy-spinner",
    templateUrl: "./busy-spinner.component.html",
    styleUrls: ["./busy-spinner.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class BusySpinnerComponent {
    @Input() size: BusySpinnerSize = "2";

    get sizeClass(): string {
        return `fa-${this.size}x`;
    }
}

type BusySpinnerSize = "1" | "2" | "3" | "4" | "5";
